import {StyleSheet} from 'react-native';

import {cloudLight, grayscale} from '/theme/color/on.color';
import {denim} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  base: {},
  heading: {
    marginBottom: 10,
    paddingRight: 10,
  },
  infoDataheading: {
    paddingRight: 10,
  },
  subheading: {
    marginBottom: 20,
  },
  CSBsubheading: {
    marginBottom: 0,
  },
  link: {
    color: denim,
    textDecorationLine: 'underline',
  },
  buttons: {
    marginBottom: 15,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  sortBase: {
    flexShrink: 1,
    marginRight: 10,
  },
  sortText: {
    flexShrink: 1,
  },
  infoIcon: {
    color: grayscale,
  },
  flexDirection: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  modal: {
    backgroundColor: grayscale,
    width: '100%',
    margin: 0,
  },
  headerText: {
    fontSize: 16,
    fontWeight: '600',
    marginLeft: 10,
    paddingVertical: 20,
    paddingHorizontal: 10,
  },
  boldText: {
    fontSize: 14,
    fontWeight: '600',
    paddingHorizontal: 10,
    lineHeight: 21,
  },
  divider: {
    height: 1,
    backgroundColor: cloudLight,
    marginHorizontal: 15,
    marginBottom: 10,
  },
});
